import React, { useEffect, useState } from 'react';
import { Button, Tooltip, Upload, message } from 'antd';
import { api } from 'react-structure-admin';
import { PaperClipOutlined } from '@ant-design/icons';
import { FaQrcode } from 'react-icons/fa';
import ShowFilesModal from './ShowFilesModal';
import SharingFileQRCode from './SharingFileQRCode';

const supportedTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/png',
  'image/webp',
  'audio/mpeg',
  'application/vnd.oasis.opendocument.presentation',
  'application/pdf',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
  'text/csv',
  'image/svg+xml'
];

const UploadList = ({
  value = [],
  onChange,
  disabled,
  onUpload,
  hiddenQrCode,
  params,
  showRemove = false,
  types = supportedTypes
}) => {
  const [files, setFiles] = useState([]);
  const [openShowFile, setOpenShowFile] = useState(null);
  const [openSharingQRCode, setOpenSharingQRCode] = useState(false);

  const normalizeFile = (file, status = 'done') => {
    return {
      uid: file.id,
      name: file.name,
      status,
      url: `${process.env.REACT_APP_API_URL}/archives/${file.id}/binary`,
      thumbUrl: `${process.env.REACT_APP_API_URL}/archives/${file.id}/binary`,
      extension: file.extension
    };
  };

  if (!Array.isArray(value)) {
    value = [];
  }

  const handleOnRemove = (file) => {
    onChange(value.filter((c) => c.id !== file.uid));
  };

  const handlePreview = (file) => {
    setOpenShowFile(value.find((c) => c.id === file.uid));
  };

  const handleClosePreview = () => {
    setOpenShowFile(null);
  };

  const handleDownload = (file) => {
    const link = document.createElement('a');
    link.href = file.url;
    link.download = file.name;
    link.click();
  };

  const handlerUploadError = () => {
    message.error('Ocorreu um erro inesperado ao processar sua solicitação.');
  };

  const handleOnChange = (newFile) => {
    onChange([...value, newFile]);

    if (onUpload) {
      onUpload(newFile);
    }
  };

  const customRequest = (options) => {
    const data = new FormData();

    data.append('file', options.file);

    if (params) {
      Object.keys(params).forEach((key) => {
        data.set(key, params[key]);
      });
    }

    options.file.status = 'uploading';
    setFiles([...files, options.file]);

    api.post('archives', data).then((response) => {
      if (!(response && response.errors)) {
        handleOnChange(response.data.result);
        options.onSuccess(options.file, options.data);

        return;
      }

      options.onError();
      handlerUploadError();
    });
  };

  const beforeUpload = (file) => {
    const allows = types.includes(file.type);

    if (!allows) {
      message.error(
        `Esse tipo de arquivo (${file.type}) não é permitido para anexos.`
      );
      return false;
    }

    const isLt3M = file.size / 1024 / 1024 <= 3;

    if (!isLt3M) {
      message.error('O tamanho do arquivo não pode ser superior a 3MB!');
    }

    return isLt3M;
  };

  useEffect(() => {
    setFiles(value.map(normalizeFile));
  }, [value]);

  return (
    <>
      {openSharingQRCode ? (
        <SharingFileQRCode
          onClose={() => setOpenSharingQRCode(false)}
          onNewUpload={handleOnChange}
        />
      ) : null}
      {openShowFile && (
        <ShowFilesModal
          files={value}
          initialValue={openShowFile}
          onClose={handleClosePreview}
        />
      )}

      {!hiddenQrCode ? (
        <Tooltip title="Receber anexos em outros dispositivos">
          <Button
            type="ghost"
            icon={<FaQrcode />}
            onClick={() => setOpenSharingQRCode(true)}
          />
        </Tooltip>
      ) : null}

      <Upload
        fileList={files}
        onRemove={handleOnRemove}
        onDownload={handleDownload}
        onPreview={handlePreview}
        customRequest={customRequest}
        beforeUpload={beforeUpload}
        showUploadList={{
          showDownloadIcon: true,
          showRemoveIcon: showRemove
        }}
      >
        {!disabled ? (
          <Button
            className="gx-w-100"
            type="ghost"
            icon={<PaperClipOutlined />}
          >
            Anexar
          </Button>
        ) : null}
      </Upload>
    </>
  );
};

export default UploadList;
